export const TERMINAL_HOLD_STATUS_VALUES = [
  'available',
  'cancelled',
  'chassis_damage',
  'closed_area',
  'cpsc',
  'customs',
  'customs_and_exam',
  'customs_and_line_hold',
  'damaged',
  'demurrage',
  'dwell',
  'exam',
  'fda_hold',
  'lcl_hold',
  'line_hold',
  'no_204',
  'no_appt_available',
  'not_available',
  'pga_hold',
  'service_hold',
  'terminal_hold',
  'tmf_and_ctf',
].sort();
